/** Message from a rejected thunk. Redux Toolkit sets error.message to "Rejected" when the thunk used rejectWithValue. */
export function actionMessage(
  result: { payload?: unknown; error?: { message?: string } | string },
  fallback: string,
): string {
  if (typeof result.payload === 'string' && result.payload.trim()) return result.payload;
  if (typeof result.error === 'string' && result.error && result.error !== 'Rejected') return result.error;
  if (result.error && typeof result.error === 'object' && result.error.message && result.error.message !== 'Rejected') {
    return result.error.message;
  }
  return fallback;
}

export function selectionClosed(message: string): boolean {
  return /avatar selection is not open/i.test(message);
}

export function avatarTaken(message: string): boolean {
  return /already taken|already been selected|already selected/i.test(message);
}
